<template>
    <div>
        <nav-bar-main></nav-bar-main>
        <!-- <nav-bar-report></nav-bar-report> -->


        <!--- Loader per il caricamento pagina o invio dei comandi -->
        <Loader />


        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <!-- banner per pro expired -->
        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning"
            style="display:inline-block;width:100%;padding:0.25rem;">
            <banner-pro-expired />
        </b-alert>
        <!-- <b-row class="mt-5">
            <Charts />
        </b-row> -->
        <b-row class="mt-5">
            <b-col cols="12">
                <b-card class="home-widget text-widget radius-card ml-4 mr-4 mb-4">
                    <template v-slot:header style="background-color:white">

                        <div class="d-flex justify-content-between align-items-center pt-2">

                            <div>
                                <span class="mr-2 h5">{{ $t("mains_logs.title_graph") }}</span>
                            </div>

                            <div class="d-flex align-items-center flex-wrap">
                                <div class="d-flex align-items-center mr-3">
                                    <label for="unit-select" class="mb-0 mr-2 text-muted" style="font-size: 0.9rem;">
                                        {{ $t('mains_logs.central_unit_selection') }}:
                                    </label>
                                    <b-form-select
                                        id="unit-select"
                                        v-model="selectedUnit"
                                        :options="unitOptions"
                                        size="sm"
                                        class="w-auto"
                                        style="max-width: 200px;"
                                    ></b-form-select>
                                </div>
                                <div class="d-flex align-items-center mr-3">
                                    <label for="start-datetime" class="mb-0 mr-2 text-muted" style="font-size: 0.9rem;">
                                        {{ $t('mains_logs.start_time') }}:
                                    </label>
                                    <b-form-datepicker
                                        v-model="startDateSel"
                                        size="sm"
                                        locale="it"
                                        class="mr-1"
                                        style="max-width: 150px;"
                                    ></b-form-datepicker>
                                    <b-form-timepicker
                                        v-model="startTimeSel"
                                        size="sm"
                                        locale="it"
                                        class="time-picker-compact"
                                        style="max-width: 100px;"
                                    ></b-form-timepicker>
                                </div>
                                <div class="d-flex align-items-center mr-3">
                                    <label for="end-datetime" class="mb-0 mr-2 text-muted" style="font-size: 0.9rem;">
                                        {{ $t('mains_logs.end_time') }}:
                                    </label>
                                    <b-form-datepicker
                                        v-model="endDateSel"
                                        :max="maxDate"
                                        size="sm"
                                        locale="it"
                                        class="mr-1"
                                        style="max-width: 150px;"
                                    ></b-form-datepicker>
                                    <b-form-timepicker
                                        v-model="endTimeSel"
                                        size="sm"
                                        locale="it"
                                        class="time-picker-compact"
                                        style="max-width: 100px;"
                                    ></b-form-timepicker>
                                </div>
                                <div class="d-flex align-items-center mr-3">
                                    <b-button variant="primary" size="sm" @click="aggiornaFetchLogbookData" :disabled="loading">
                                        <b-spinner v-if="loading" small></b-spinner>
                                        {{ $t('mains_logs.fetch_data') }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="chart-container">
                        <transition name="fade">
                            <button
                                v-if="showReset"
                                @click="handleResetZoom"
                                class="btn-reset-floating"
                                :title="$t('mains_logs.reset_zoom')"
                            >
                                <i class="fas fa-undo"></i> {{ $t('mains_logs.reset_zoom') }}
                            </button>
                        </transition>
                        <MainsStepLineChart
                            v-if="!loading && error == null && logbookList != null"
                            :chartData="chData"
                            :startTimeMs="startTimeMs"
                            :endTimeMs="endTimeMs"
                            id="MainsStateChart"
                            ref="myChartComponent"
                            @update-bounds="handleUpdateBounds"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card class="home-widget text-widget radius-card ml-4 mr-4 mb-4" style="background-color:white;">
                    <template v-slot:header class="card-header">
                        <div class="d-flex justify-content-between align-items-center pt-2">
                        <!-- <div class="pt-2"> -->
                            <span class="mr-2 h5">{{ $t("mains_logs.title") }}<br /></span>
                            <b-button v-if="logbookList != null && logbookList.length > 0" class="noborder-button download mt-2" @click="createPDF_Logs">
                            <i class="fas fa fa-1x fa-download mr-2"></i>{{ $t("download") }}
                            </b-button>
                        </div>
                    </template>

                    <v-client-table
                        v-if="!loading && error == null && logbookListSoloReali != null"
                        :data="filteredLogbookListSoloReali"
                        :columns="columnsLogs"
                        :options="optionsLogs"
                        :theme="theme"
                        id="dataTable"
                        ref="table"
                        class="borderless text-primary widget-table">

                        <template slot="time_ms" slot-scope="props">
                            {{ formatDisplayDate(props.row.time_ms) }}
                        </template>

                    </v-client-table>
                </b-card>
            </b-col>
        </b-row>
    </div>

</template>
<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import NavBarReport from '@/components/NavBarReport';
import BannerPro from '@/components/BannerPro';
import BannerProExpired from '@/components/BannerProExpired';
import ErrorBanner from '@/components/ErrorBanner';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
import {ClientTable} from 'vue-tables-2';
import { showAt, hideAt } from 'vue-breakpoints';
import MainsStepLineChart from '@/components/MainsStepLineChart.vue';
import Charts from '@/views/Charts.vue';
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";

Vue.use(ClientTable);

export default {
    name: 'ReportMains',
    components: {
        NavBarMain,
        NavBarReport,
        BannerPro,
        BannerProExpired,
        Loader,
        ErrorBanner,
        ClientTable, // Register the component
        showAt,
        hideAt,
        MainsStepLineChart,
        Charts,
        jsPDF
    },
    props: ['plantId', 'devicesType'],
    data() {
        return {
            maxDate: new Date(),
            //data/ora inizio
            startDate: null,
            startTime: null,
            //data/ora fine
            endDate: null,
            endTime: null,
            //copie usate nella maschera di selezione
            startDateSel: null,
            startTimeSel: null,
            endDateSel: null,
            endTimeSel: null,

            columnsLogs: [
                'time_ms',
                'cu_id',
                'mains',
                //'isVirtual'
            ],
            optionsLogs: {
                uniqueKey: "cu_id" + "time_ms", // Unique key for each row,
                // Defines the human-readable header for each column key
                headings: {
                    time_ms: this.$t('mains_logs.date'),
                    cu_id: this.$t('mains_logs.id'),
                    mains: this.$t('mains_logs.state'),
                    //isVirtual: this.$t('mains_logs.event_type')
                },
                // Configuration for pagination, filtering, etc.
                filterable: ['cu_id'],
                pagination: { chunk: 5, dropdown: false, },
                perPage: 10,
                perPageValues: [10, 20, 50],
                sortable: ['time_ms', 'cu_id'],
                orderBy: { column: 'time_ms', ascending: false }, // Sort by latest timestamp first
                texts: {
                    limit: this.$t("report_table.record_per_page"),
                    count: "{count} item"
                },
            },
            theme: "bootstrap4",
            // Data properties to hold the loaded font strings
            robotoRegular: null,
            robotoBold: null,
            chData: {
                labels: [],
                datasets: []
            },
            selectedUnit: 0,
            showReset: false, //per visualizzare il pulsante di reset dello Zoom
            currentBounds: null,
            debounceTimer: null,
            //logo BEGHELLI in formato base64, usato se non dovesse esistere quello dell'impianto
            imgData : 'data:image/jpeg;base64,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'

        };
    },
    computed: {
        ...mapState(['loading', 'error']),

        // maxTime() {
        //   const today = new Date().toISOString().split('T')[0]; //format YYYY-MM-DD
        //   console.log("today: ", today, " endDateSel: ", this.enddateSel);
        //   // if the selected date is today, limit time to now
        //   if (this.endDateSel === today) {
        //     const now = new Date();
        //     return `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
        //   }
        //   //otherwise, allow any time
        //   return null;
        // },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },

        //Lista di CU per la select
        unitOptions() {
            if (this.plantDetails == null) return [];
            //definisco l'opzione "all" per prima
            const firstOption = [{
                value: 0,
                text: this.$t("mains_logs.all_units")
            }];
            const unitList = this.plantDetails.controlunits?.map(unit => ({
                value: unit.cuid,
                text: unit.cuid + ' ' + unit.cudesc
            }));
            // Ritorna l'array combinato (opzione 'All' + unità)
            // Usiamo concat e l'operatore OR per gestire il caso in cui controlunits sia vuoto
            return firstOption.concat(unitList || []);
        },

        //Lista dei logbook recuperata dallo store
        logbookList() {
            console.log("mains logs:", this.$store.state.MainsLogbooks);
            if (this.$store.state.MainsLogbooks == null) return null;
            return this.$store.state.MainsLogbooks.map( log => { //restituisce un nuovo array ai cui elementi è stata aggiunta la property time_ms
                // 0. appiattimento dello stato precedente (punto extra per migliore resa grafica) al tempo iniziale della query
                const startTimeSec = this.startTimeMs / 1000;
                //console.log("startTimeSec:", startTimeSec, "log.timestamp:", log.timestamp);
                if (Number(log.timestamp) < startTimeSec) {
                    //console.log("appiattimento dello stato precedente", log.timestamp, startTimeSec);
                    log.timestamp = startTimeSec.toString();
                    log.cu_timestamp = log.cu_timestamp.split('#')[0] + '#' + log.timestamp;
                    log.isVirtual = true; //segnalo che non è un punto vero, ma elaborato
                }
                const time_ms = log.timestamp * 1000; //transforme in milliseconds
                return {
                    ...log,
                    time_ms: time_ms,
                }
            });
        },
        //Fornisce solo i punti reali alla tabella degli stati
        logbookListSoloReali() {
            if (this.logbookList == null) return null;
            return this.logbookList.filter(log => !log.isVirtual);
        },
        //filtra i punti rispetto ai nuovi limiti dell'asse x imposti dalllo zoom
        filteredLogbookListSoloReali() {
            //se non c'è zoom, mostro tutto
            if (!this.currentBounds) return this.logbookListSoloReali;
            //destrutturo i nuovi bounds
            const { min, max } = this.currentBounds;
            //filtro i logbook in base ai nuovi limiti
            return this.logbookListSoloReali.filter(log => log.time_ms >= min && log.time_ms <= max);
        },

        //Combina data e ora in timestamp di inizio (ms)
        startTimeMs() {
            //usa Moment.js per combinare Data (YYYY-MM-DD) e Ora (HH:mm:ss)
            const startDateTime = `${this.startDate} ${this.startTime}`;
            //restituisce il timestamp in millisecondi
            return moment.utc(startDateTime, 'YYYY-MM-DD HH:mm').valueOf();
        },
        //Combina data e ora in timestamp di fine (ms)
        endTimeMs() {
            const endDateTime = `${this.endDate} ${this.endTime}`;
            return moment.utc(endDateTime, 'YYYY-MM-DD HH:mm').valueOf();
        },
    },

    mounted() {
        // Al caricamento, imposta il range delle ultime 24 ore e chiama l'API
        this.setInitialDates();
        if (this.$store.state.user != null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.fetchLogbookData();
        }
        // Load fonts when the component is mounted
		    this.loadFonts();
    },
    watch: {
        // '$route'() {
        //     // TODO: react to navigation event.
        //     // params cotains the current route parameters
        //     console.log("route changed!",this.$route.params, this.devicesType);
        //     this.tipoDispositivo = this.devicesType;
        // },
        //Occorre monitorare loading per caricare i dettagli della plant e delle unità, altrimenti a fronte di un F5 non si caricano e non si vede nulla neppure
        //in MainContainer.vue
        loading(val) {
            console.log("loading changed:" + val+", error=" + this.error + ", unit details=", this.unitsDetails)
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId);
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details");
                this.$store.dispatch('loadUnitsDetails', this.plantId);
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null && this.logbookList == null && this.error == null) {
                this.fetchLogbookData();
            }
        },
        //viene invocato quando la computed property 'logbookList' cambia, e prepara i datasets per Chart.js
        logbookList(val) {
            if (val == null || val.length === 0) {
                //se la lista è vuota, pulisci i dataset
                this.chData.datasets = [];
                return;
            }
            // 1. raggruppamento dei dati per cu_id -> restituisce un array i cui elementi sono ulteriori array, uno per ogni cu
            const groupedData = val.reduce((acc, log) => {
                //inizializza l'array per questo cu_id se non esiste
                if (!acc[log.cu_id]) {
                    acc[log.cu_id] = [];
                }
                //aggiungo il log nel formato {t: timestamp, y: valore}
                acc[log.cu_id].push({
                    t: log.time_ms,
                    y: log.mains == 'ON' ? 1 : 0
                });

                return acc;
            }, {}); //l'accumulatore iniziale è un oggetto vuoto

            // 2. creazione dei dataset ristrutturati
            const newDatasets = [];
            //colori
            const colors = [
                'rgba(54, 162, 235, 1)', //blu
                'rgba(255, 99, 132, 1)', //rosso
                'rgba(75, 192, 192, 1)', //verde
                'rgba(255, 206, 86, 1)', //giallo
                'rgba(153, 102, 255, 1)', //viola
                'rgba(255, 159, 64, 1)', //arancione
                'rgba(255, 99, 71, 1)', //carmine
                'rgba(0, 128, 0, 1)', //verde scuro
                'rgba(255, 69, 0, 1)', //arancione scuro
                'rgba(128, 0, 128, 1)', //viola scuro
            ];
            let colorIndex = 0;
            for (const cuId in groupedData) { //applicato ad un array, fornisce gli indici
                //crea un nuovo dataset per ogni cu_id
                const dataset = {
                    label: cuId,
                    backgroundColor: colors[colorIndex % colors.length], //cicla i colori
                    borderColor: colors[colorIndex % colors.length],
                    borderWidth: 2,
                    pointRadius: 0, //punto invisibile
                    pointHitRadius: 20, //crea una bolla di 20px attorno al punto perché sia più facile intercettarlo
                    pointHoverRadius: 5, //mostra un puntino quando ci sei sopra
                    data: this.interpolateSteppedData(groupedData[cuId])
                };
                // 3. aggiunge al dataset
                newDatasets.push(dataset);
                colorIndex++;
            }
            // 4. aggiorna la proprietà dati del grafico
            this.chData.datasets = newDatasets;
            console.log("datasets raggruppati: ", this.chData.datasets);

        }
    },
    methods: {
      //gestisce i nuovi bounds del grafico dopo uno zoom
      handleUpdateBounds(bounds) {
          //annulliamo un eventuale precedente timer di debouncing memorizzato in this.debounceTimer
          clearTimeout(this.debounceTimer);
          //aspetta 100ms di 'silenzio' prima di aggiornare la tabella
          this.debounceTimer = setTimeout(() => {
              //se la vista attuale è praticamente uguale a quella iniziale, nascondo il reset
              const isInitialView = Math.abs(bounds.min - this.startTimeMs) < 1000 &&
                                    Math.abs(bounds.max - this.endTimeMs) < 1000;
              this.showReset = !isInitialView;
              this.currentBounds = bounds;
          }, 100);

      },
      //resetta lo zoom del grafico
      handleResetZoom() {
          //invoca il reset delk componente figlio 'myChartComponent'
          const chartInstance = this.$refs.myChartComponent.$data._chart;
          if (chartInstance) {
              chartInstance.resetZoom();
          }
          this.currentBounds = null; //azzeri i bounds attuali
          //nascondo il pulsante
          this.showReset = false;
      },

        //Loads all required fonts and stores them in component data.
      async loadFonts() {
        try {
          // Assumes fonts are in your 'public' folder
          this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
          this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
          //console.log('Fonts loaded successfully.');
        } catch (error) {
          console.error('Failed to load fonts:', error);
        }
      },
      // Helper function to load a font from a URL and convert it to Base64
      async loadFontAsBase64(url) {
        const response = await fetch(url);
        // console.log("fetch font: ", response);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            // Get the Base64 string, but strip the "data:..." prefix
            const base64data = reader.result.split(',')[1];
            resolve(base64data);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      },
      //funzione che formatta il timestamp in una stringa leggibile
      formatDisplayDate(timestamp) {
          if (!timestamp) return '-';
          const date = new Date(Number(timestamp));
          return date.toLocaleString('it-IT', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZone: 'UTC'
          });
      },
      //funzione che fissa i parametri di data e ora per la visualizzazione iniziale
      setInitialDates() {
          const endMoment = moment(); //ora attuale
          const startMoment = moment().subtract(24, 'hours'); //24 ore fa
          this.startDate = startMoment.format('YYYY-MM-DD');
          this.startTime = startMoment.format('HH:mm');
          this.endDate = endMoment.format('YYYY-MM-DD');
          this.endTime = endMoment.format('HH:mm');
          this.startDateSel = this.startDate;
          this.startTimeSel = this.startTime;
          this.endDateSel = this.endDate;
          this.endTimeSel = this.endTime;
          console.log("setInitialDates: ", this.startDate, this.startTime, this.endDate, this.endTime);
      },
      //funzione richiamata dal pulsante 'Aggiorna Grafico'
      //passa i nuovi limiti temporali alla funzione di fetch
      async aggiornaFetchLogbookData() {
          this.startDate = this.startDateSel;
          this.startTime = this.startTimeSel;
          this.endDate = this.endDateSel;
          this.endTime = this.endTimeSel;
          this.showReset = false; //nascondo il pulsante di reset zoom
          this.currentBounds = null; //azzero i bounds attuali
          this.fetchLogbookData();
      },
      //Funzione che invoca la funzione di store che richiede i MainsLogbooks
      async fetchLogbookData() {
          try {
              //cnnverto le date/ore dei picker in timestamp Epoch (s)
              const startTimestamp = this.startTimeMs / 1000;
              const endTimestamp = this.endTimeMs / 1000;
              let cuIdSet = null;
              const cuId = this.selectedUnit == 0 ? null : this.selectedUnit; //0 significa ALL, quindi tutto l'impianto (cuId = null)
              //nel caso si ricerchi tutto l'impianto, passo la lista ‘cuIdSet’
              if (cuId == null) {
                  cuIdSet = this.unitsDetails.map(unit => unit.cu_type + '_' + unit.cu_id);
              }
              console.log("unitsDetails: ", this.unitsDetails);
              console.log("plantDetails: ", this.plantDetails);
              const type = this.unitsDetails.find(unit => unit.cu_id == cuId)?.cu_type;
              let parameters = {
                  plantId: this.plantId,
                  cuId: cuId,
                  startTime: startTimestamp.toString(),
                  endTime: endTimestamp.toString(),
                  type: type,
                  cuIdSet: cuIdSet //aggiungo la lista delle CU per consentire al backend di trovare i punti iniziali
              }
              console.log("fetchLogbookData parameters:", parameters);
              this.$store.dispatch('loadMainsLogbooks', parameters);
          } catch (error) {
              console.error('Error fetching logbook Mains:', error);
          }
      },
      // Funzione che effettua una Interpolazionedel Valore, che consiste nell'aggiungere punti di dati fittizi
      // per creare manualmente l'effetto di gradino
      interpolateSteppedData(chartDataPoints) {
          if (!chartDataPoints || chartDataPoints.length === 0) return [];
          const finalData = [];
          chartDataPoints.forEach((log, index) => {
              // 1. Aggiungi il punto che segna l'inizio del nuovo stato (il vero evento)
              console.log("currentValue: ", log.t);
              const currentValue = log.y;
              finalData.push({ t: log.t, y: currentValue});
              // 2. Se non siamo all'ultimo punto, aggiungiamo il punto fittizio che mantiene il valore
              if (index < chartDataPoints.length - 1) {
                  const nextTime = chartDataPoints[index + 1].t;
                  // Punto fittizio:
                  // - Mantiene il VALORE ATTUALE (currentValue)
                  // - È posizionato un millisecondo (1ms) prima del prossimo evento (nextTime)
                  finalData.push({ t: nextTime - 1, y: currentValue });
              }
          });
          // Ordina per tempo se l'array non è garantito cronologico (anche se dovrebbe esserlo)
          finalData.sort((a, b) => a.t - b.t);
          console.log("finalData:", finalData);
          return finalData;
      },

      async createPDF_Logs() {
          var risp = true;
          //nel caso siano attivi dei filtri che riducono i punti, avviso con un modal
          if (this.$refs.table.count < this.logbookListSoloReali.length) {
              risp = await this.$bvModal.msgBoxConfirm(this.$t("mains_logs.range_reduced"), {
              title: this.$t("mains_logs.title_range_reduced"),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'dark',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true,
              });
          }
          if (risp == true) {
              //recupero i dati attualmente mostrati nella tabella (ref="table") dopo il filtraggio e l'ordinamento
              var rowsPoint = this.$refs.table.allFilteredData;

              //creo una copia con time_ms formattata tramite formatDisplayDate()
              const formattedBody = rowsPoint.map((row, index) => ({
                  ...row,
                  displayIndex: index + 1, //indice incrementale di punto
                  displayData: this.formatDisplayDate(row.time_ms) //creiamo una nuova chiave
              }));

              //Set heading for Point pdf table
              var columnsPointPdf = [
                  {title: '#', dataKey: "displayIndex"},
                  {title: this.$t('mains_logs.date'), dataKey: "displayData"},
                  {title: this.$t('mains_logs.id'), dataKey: "cu_id"},
                  {title: this.$t('mains_logs.state'), dataKey: "mains"},
              ];

              //Define table name
              let plant_header = this.plantDetails.plantname.replaceAll(".","");
              let table_name = this.$t("bom.name_pdf") + plant_header;

              // Only pt supported (not mm or in)
              //var doc = new jsPDF('p', 'pt');
              // Only pt supported (not mm or in)
              const doc = new jsPDF({
                  orientation: 'p',
                  unit: 'pt',
                  format: 'a4',
                  putOnlyUsedFonts: true,
                  floatPrecision: 16
              });

              doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
              doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
              // Use 'Identity-H' encoding for the font registration to enable Unicode support
              doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
              doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

              doc.setFont('Roboto', 'bold');
              // doc.setFont('Helvetica')
              // doc.setFontType("bold");
              doc.setFontSize(12);

              var date_now = new Date();

              //Inserimento del logo come intestazione al PDF
              if (this.plantDetails.logoId != null) {
                  console.log("Esiste il logo!");
                  let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
                  var logoImg = new Image();
                  logoImg.src = logoUrl;
                  var logoData = await this.getImageData(logoImg);
                  var w = 60 * logoImg.width / logoImg.height;
                  doc.addImage(logoData, 'PNG', 38, 15, w, 60);
              } else {
                  doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
              }

              //Inserimento dati impianto in pdf
              doc.text(this.$t('report_pdf.title_impianto') + " : " +  this.plantDetails.plantname,38,95);

              doc.setFont('Roboto', 'normal');
              doc.setFontSize(10);
              doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber,38,110);
              doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov +") " + this.plantDetails.address.country,38,125);

              doc.setFont('Roboto', 'bold');
              doc.setFontSize(14);
              doc.text(this.$t('mains_logs.title_pdf').toUpperCase(),38,200);

              doc.setFont('Roboto', 'normal');
              doc.setFontSize(11);
              doc.text(date_now.toLocaleDateString() + " - " + date_now.toLocaleTimeString(), 38, 220);

              doc.setFontSize(8);

              //inserimento del grafico
              const chartComponent = this.$refs.myChartComponent;
              if (chartComponent) {
                  //recupero il grafico richiamndo il metodo ad hoc
                  const chartImage = chartComponent.getChartImage();
                  if (chartImage) {
                      //inserisco il grafico nel pdf
                      doc.addImage(chartImage, 'PNG', 38, 250, 500, 150);
                  }
              }
              //Table report plant
              doc.autoTable({
                  columns: columnsPointPdf,
                  body: formattedBody,
                  columnStyles: {
                      displayIndex: { cellWidth: 'auto' }, //indice con larghezza fissa ridotta
                  },
                  headStyles : {
                      font: "Roboto",
                      fontSize: 11,
                      fillColor : [59, 156, 204]
                  },
                  styles: {
                      font: "Roboto",
                      fontSize: 10
                  },
                  alternateRowStyles: {fillColor : [225, 238, 245]},
                  tableLineColor: [59, 156, 204],
                  tableLineWidth: 0.1,
                  startY: 450,
              });

              doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
              doc.save(table_name);
          }
      },

      // Method to convert the UNIX timestamp (e.g., '1763563470') to a human-readable date/time
      formatTimestamp(unixTimestamp) {
          const date = new Date(parseInt(unixTimestamp)); // Convert to Date
          return date.toLocaleString(); // Format to local date and time string
      },

      //--------------------------------------------------------------------------------------------------------
      //esegue una invocazione HTTP GET verso AWS Gateway per recuperare un'immagine
      //--------------------------------------------------------------------------------------------------------
      async getImageData(logo) {
          logo.crossOrigin="anonymous";
          await logo.decode();
          console.log("immagine:" + logo.width + "x" + logo.height ,logo);
          var canvas = document.createElement("canvas");
          canvas.width = logo.width;
          canvas.height = logo.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(logo, 0, 0);
          var dataURL = canvas.toDataURL("image/png");
          //console.log("logo dataurl:" + dataURL);
          return dataURL;
      },
    }
}
</script>
<style scoped>
    .chart-container {
        position: relative;
        height: 400px;
        width: 100%;
        margin-bottom: 20px;
    }
    .btn-reset-floating {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 10;
        background-color: rgba(255, 255, 255, 0.8);
        color: #333;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 12px;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: all 0.2s ease;
    }
    .btn-reset-floating:hover {
        background-color: #f8f9fa;
        border-color: #bbb;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }
    /*animazione di entrata/uscita*/
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
